import { render, staticRenderFns } from "./ThankyouPayment.vue?vue&type=template&id=1c4db5d6&scoped=true"
import script from "./ThankyouPayment.vue?vue&type=script&lang=js"
export * from "./ThankyouPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4db5d6",
  null
  
)

export default component.exports